// The official player-count → team distribution, and the "Randomize All" draw built on it.
// Pure functions with an injectable random source so the server can be tested deterministically.
/** Official player-count → [townsfolk, outsider, minion, demon]. */
export const DISTRIBUTION = {
    5: [3, 0, 1, 1], 6: [3, 1, 1, 1], 7: [5, 0, 1, 1], 8: [5, 1, 1, 1], 9: [5, 2, 1, 1],
    10: [7, 0, 2, 1], 11: [7, 1, 2, 1], 12: [7, 2, 2, 1], 13: [9, 0, 3, 1], 14: [9, 1, 3, 1], 15: [9, 2, 3, 1],
};
const DIST_TEAMS = ["townsfolk", "outsider", "minion", "demon"];
export const MAX_REGULAR_PLAYERS = 15;
function shuffle(arr, rand) {
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(rand() * (i + 1));
        const ai = a[i], aj = a[j];
        a[i] = aj;
        a[j] = ai;
    }
    return a;
}
/**
 * A random, correctly balanced set of characters for the player count, from the base distribution
 * table only; setup-changing characters (a Baron's extra Outsiders) are for the Storyteller to
 * apply by hand. Travelers are never drawn.
 */
export function randomizeCharacters(scriptCharacters, playerCount, rand = Math.random) {
    const dist = DISTRIBUTION[playerCount];
    if (!dist) {
        return { ok: false, error: `Randomize only supports 5-15 players (this game has ${playerCount}).` };
    }
    const pools = { townsfolk: [], outsider: [], minion: [], demon: [] };
    for (const c of scriptCharacters) {
        if (c.team && c.team in pools)
            pools[c.team].push(c);
    }
    const need = {
        townsfolk: dist[0], outsider: dist[1], minion: dist[2], demon: dist[3],
    };
    for (const team of DIST_TEAMS) {
        if (pools[team].length < need[team]) {
            return {
                ok: false,
                error: `This script only has ${pools[team].length} ${team} character(s), but ${playerCount} players need ${need[team]}.`,
            };
        }
    }
    const chosen = [];
    for (const team of DIST_TEAMS)
        chosen.push(...shuffle(pools[team], rand).slice(0, need[team]));
    return { ok: true, characters: shuffle(chosen, rand) };
}
//# sourceMappingURL=distribution.js.map